// Core
import { Box, Flex, Text } from '@chakra-ui/react';
import { GiGemini, GiAries, GiTaurus, GiCancer, GiLeo, 
  GiVirgo, GiLibra, GiScorpio, GiSagittarius, GiCapricorn, 
  GiAquarius, GiPisces } from 'react-icons/gi';

// Assets
import { getAge } from '../../../services/Utils';
import { textLang } from 'services/Lang';

const zodiacSigns = [
  { name: 'Aries', icon: GiAries, start: '03-21', end: '04-19' },
  { name: 'Taurus', icon: GiTaurus, start: '04-20', end: '05-20' },
  { name: 'Gemini', icon: GiGemini, start: '05-21', end: '06-20' },
  { name: 'Cancer', icon: GiCancer, start: '06-21', end: '07-22' },
  { name: 'Leo', icon: GiLeo, start: '07-23', end: '08-22' },
  { name: 'Virgo', icon: GiVirgo, start: '08-23', end: '09-22' },
  { name: 'Libra', icon: GiLibra, start: '09-23', end: '10-22' },
  { name: 'Scorpio', icon: GiScorpio, start: '10-23', end: '11-21' },
  { name: 'Sagittarius', icon: GiSagittarius, start: '11-22', end: '12-21' },
  { name: 'Capricorn', icon: GiCapricorn, start: '12-22', end: '01-19' },
  { name: 'Aquarius', icon: GiAquarius, start: '01-20', end: '02-18' },
  { name: 'Pisces', icon: GiPisces, start: '02-19', end: '03-20' },
];


const getZodiacSign = (birthDate) => {
  const date = new Date(birthDate);
  const monthDay = `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

  return zodiacSigns.find(
    (sign) =>
      (monthDay >= sign.start && monthDay <= sign.end) ||
      (sign.name === 'Capricorn' && (monthDay >= sign.start || monthDay <= sign.end))
  );
};

const BirthInfo = ({ birthDate, color }) => {
  const age = getAge(birthDate);
  const zodiac = getZodiacSign(birthDate);
  const Icon = zodiac?.icon || null;

  const colorMatch = color ? color : 'white';

  return (
    <Flex justifyContent="start" alignItems="center" w="100%">
      <Flex alignItems="center" gap={2}>
        {Icon && <Icon color={colorMatch} size={20} />}
        <Text variant="title-md" color={colorMatch} textShadow="0.5px 0.5px black">{textLang(zodiac?.name)}</Text>
      </Flex>
      <Text variant="title-md" color={colorMatch} textShadow="0.5px 0.5px black">, {age}</Text>
    </Flex>
  );
};

export default BirthInfo;
